import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../CartContext/CartProvider';
import { BiCategoryAlt } from "react-icons/bi";
import { IoSearchOutline } from "react-icons/io5";
import { MdOutlineAccountCircle } from "react-icons/md";
import { FaShoppingCart } from "react-icons/fa";
import { IoHome } from "react-icons/io5";
const Cart = () => {
  const { cartItems, removeFromCart } = useCart();
  const navigate = useNavigate();
  console.log("cart",cartItems)
  useEffect(() => {
    const hasRefreshed = sessionStorage.getItem("hasRefreshed");
  
    if (!hasRefreshed) {
      sessionStorage.setItem("hasRefreshed", "true");
      window.location.reload();
    }
  }, []);
  
  const getCurrentDate = () => {
    const date = new Date();
    return date.toLocaleDateString('en-GB'); // Format: DD/MM/YYYY
  };

  const calculateSubTotal = () => {
    return cartItems.reduce((total, item) => total + (parseFloat(item.salePrice) * 2), 0);
  };

  
  const calculateSavings = () => {
    return cartItems.reduce((total, item) => {
      const originalPrice = parseFloat(item.originalPrice || 0);
      console.log("original",item.originalPrice);
      const salePrice = parseFloat(item.salePrice || 0);
      console.log("sale",salePrice);
      return total + (originalPrice - salePrice);
    }, 0);
  };

  const isLoggedIn = localStorage.getItem("token");

  return (
    <div>
      <style>{`
        .cart-page {
          max-width: 1200px;
          margin: 0 auto;
          padding: 20px;
          font-family: Arial, sans-serif;
        }
        
        .cart-tabs {
          display: flex;
          margin-bottom: 30px;
          border-bottom: 1px solid #ddd;
        }
        
        .tab {
          padding: 10px 20px;
          font-size: 16px;
          color: #666;
        }
        
        .tab.active {
          color: #ff9f00;
          border-bottom: 2px solid #ff9f00;
        }
        
        .tab.disabled {
          color: #ccc;
          cursor: not-allowed;
        }
        
        .cart-grid {
          display: grid;
          grid-template-columns: 70% 28%;
          gap: 2%;
        }
        
        .cart-items {
          background: #fff;
          border: 1px solid #ddd;
          border-radius: 4px;
          height:fit-content;
          overflow-x:scroll;
        }
        
        .cart-table {
          width: 100%;
          border-collapse: collapse;
        }
        
        .cart-table th {
          padding: 15px;
          text-align: left;
          background: #f8f9fa;
          border-bottom: 1px solid #ddd;
        }
        
        .cart-item {
          border-bottom: 1px solid #ddd;
        }
        
        .cart-item td {
          padding: 15px;
          vertical-align: top;
        }
        
        .product-image {
          width: 100px;
          height: 120px;
          object-fit: cover;
        }
        
        .product-details {
          color: #333;
        }
        
        .product-name {
          font-weight: bold;
          margin-bottom: 5px;
        }
        
        .product-id {
          color: #666;
          font-size: 0.9em;
          margin-bottom: 5px;
        }
        
        .booking-date {
          color: #666;
          font-size: 0.9em;
        }
        
        .price {
          font-weight: bold;
          color: #333;
        }
        
        .mrp {
          text-decoration: line-through;
          color: #999;
          font-size: 0.9em;
          margin-left: 5px;
        }
        
        .cart-summary {
          background: #f8f9fa;
          padding: 20px;
          border-radius: 4px;
        }
        
        .summary-title {
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 20px;
          color: #1a237e;
        }
        
        .summary-row {
          display: flex;
          justify-content: space-between;
          margin-bottom: 15px;
          color: #333;
        }
        
        .savings {
          color: #4caf50;
          font-weight: bold;
          margin-top: 10px;
        }
        
        .total-amount {
          font-size: 1.2em;
          font-weight: bold;
          margin-top: 20px;
          padding-top: 15px;
          border-top: 1px solid #ddd;
        }
        
        .checkout-button {
          width: 100%;
          padding: 12px;
          background: #1a237e;
          color: white;
          border: none;
          border-radius: 4px;
          font-size: 16px;
          cursor: pointer;
          margin-top: 20px;
          transition: background 0.3s ease;
        }
        
        .checkout-button:hover {
          background: #0d1757;
        }
        
        .checkout-button.disabled {
          background: #cccccc;
          cursor: not-allowed;
        }
        
        .login-message {
          color: #dc3545;
          font-size: 0.9em;
          margin-top: 10px;
          text-align: center;
        }
        
        .remove-button {
          color: #dc3545;
          background: none;
          border: none;
          cursor: pointer;
          font-size: 20px;
          padding: 0;
          transition: color 0.3s ease;
        }
        
        .remove-button:hover {
          color: #bb2d3b;
        }
        
        .empty-cart {
          text-align: center;
          padding: 40px;
          color: #666;
        }
        
        @media (max-width: 768px) {
          .cart-grid {
            grid-template-columns: 1fr;
            gap: 20px;
          }
          
          .cart-table {
            font-size: 14px;
          }
          
          .product-image {
            width: 80px;
            height: 100px;
          }
        }
      `}</style>

      <div className="cart-page">
        <div className="cart-tabs">
          <div className="tab active">CART</div>
        </div>

        <div className="cart-grid">
          <div className="cart-items">
            {cartItems.length === 0 ? (
              <div className="empty-cart">
                <h3>Your cart is empty</h3>
              </div>
            ) : (
              <table className="cart-table">
                <thead>
                  <tr>
                    <th>Product</th>
                    <th>Product Details</th>
                    <th>Quantity</th>
                    <th>Deposit Amount</th>
                    <th>Sub Total</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {cartItems.map((item, index) => (
                    <tr key={index} className="cart-item">
                      <td>
                        <img 
                          src={`${item.image}`} 
                          alt={item.productName} 
                          className="product-image"
                        />
                      </td>
                      <td className="product-details">
                        <div className="product-name">{item.productName}</div>
                        <div className="product-id">Product Id: {item.sizeId}</div>
                        <div className="booking-date">
                          Booking Date: {getCurrentDate()}
                        </div>
                        <div className="price">
                          ₹{item.salePrice} {" "}
                          {item.originalPrice && (
                            <span className="mrp">₹{item.originalPrice}</span>
                          )}
                        </div>
                        {item.color && <div className="product-color">Color: {item.color}</div>}
                        {item.material && <div className="product-material">Material: {item.material}</div>}
                        {item.brandName && <div className="product-brand">Brand: {item.brandName}</div>}
                      </td>
                      <td>{item.quantity || 1}</td>
                      <td>₹{item.salePrice}</td>
                      <td>₹{item.salePrice * 2}</td>
                      <td>
                        <button 
                          className="remove-button" 
                          onClick={() => removeFromCart(index)}
                          aria-label="Remove item"
                        >
                          ×
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>

          {cartItems.length > 0 && (
            <div className="cart-summary">
              <h3 className="summary-title">CART TOTALS</h3>
              <div className="summary-row">
                <span>Products Price</span>
                <span>₹{cartItems.reduce((total, item) => total + parseFloat(item.salePrice), 0)}</span>
              </div>
              <div className="summary-row">
                <span>Refundable Security Deposit</span>
                <span>₹{cartItems.reduce((total, item) => total + parseFloat(item.salePrice), 0)}</span>
              </div>
              <div className="total-amount summary-row">
                <span>Total Amount</span>
                <span>₹{calculateSubTotal()}</span>
              </div>
              <div className="savings">
                You Have Saved ₹{calculateSavings()}
              </div>
              <button 
                className={`checkout-button ${!isLoggedIn ? 'disabled' : ''}`}
                onClick={() => {
                  if (isLoggedIn) {
                    navigate('/checkout');
                  } else {
                    navigate('/login', { state: { from: '/checkout' } });
                  }
                }}
              >
                {isLoggedIn ? 'CHECKOUT' : 'LOGIN TO CHECKOUT'}
              </button>
              {!isLoggedIn && (
                <div className="login-message">
                  Please login to proceed with checkout
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      <div class="tf-toolbar-bottom type-1150">
        <div class="toolbar-item">
            <a style={{color:"black"}} href="/">
                <div class="toolbar-icon">
                <IoHome />
                </div>
                <div class="toolbar-label">Home</div>
            </a>
        </div>
        <div class="toolbar-item">
            <a style={{color:"black"}} href="/products" >
                <div class="toolbar-icon">
                <BiCategoryAlt />
                </div>
                <div class="toolbar-label">Shop</div>
            </a>
        </div>
        <div class="toolbar-item">
            <a style={{color:"black"}} href="/SearchBar" >
                <div class="toolbar-icon">
                <IoSearchOutline />
                </div>
                <div class="toolbar-label">Search</div>
            </a>
        </div>
        <div class="toolbar-item">
            <a style={{color:"black"}} href="/cart">
                <div class="toolbar-icon">
                <FaShoppingCart />
                </div>
                <div class="toolbar-label">Cart</div>
            </a>
        </div>
    </div>
    </div>
  );
};

export default Cart;